import { produce } from "immer";
import * as uiActions from "./uiActions";

const initialState = {
  isLoading: true,
  errorMessage: null,
  deleteContactIds: null,
  deleteContactNameOrCount: null,
  deleteContactReferer: null,
  isDeleteLoading: false,
  selected: {
    byId: {},
    allIds: []
  }
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case uiActions.FETCH_CONTACTS_PENDING: {
      draft.isLoading = true;
      draft.errorMessage = null;
      break;
    }

    case uiActions.FETCH_CONTACTS_SUCCESS: {
      draft.isLoading = false;
      break;
    }

    case uiActions.FETCH_CONTACTS_FAILED: {
      draft.isLoading = false;
      draft.errorMessage = action.payload;
      break;
    }

    case uiActions.DELETE_CONTACT: {
      draft.isDeleteLoading = true;
      break;
    }

    case uiActions.SET_DELETE_CONTACT_MODAL: {
      const { payload } = action;
      draft.deleteContactIds = payload.deleteContactIds;
      draft.deleteContactNameOrCount = payload.deleteContactNameOrCount;
      draft.deleteContactReferer = payload.deleteContactReferer;
      break;
    }

    case uiActions.DELETE_CONTACT_SUCCESS: {
      draft.isDeleteLoading = false;
      draft.deleteContactIds = null;
      draft.deleteContactNameOrCount = null;
      draft.deleteContactReferer = null;
      break;
    }

    case uiActions.DELETE_CONTACT_FAILED: {
      draft.isDeleteLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;
    }

    case uiActions.UPDATE_CONTACT_FAILED: {
      draft.errorMessage = action.payload.errorMessage;
      break;
    }

    case uiActions.CLOSE_CONTACT_DELETE_MODAL: {
      draft.deleteContactIds = null;
      draft.deleteContactNameOrCount = null;
      draft.deleteContactReferer = null;
      break;
    }

    case uiActions.SELECT_SINGLE: {
      const payload = action.payload;
      if (payload.isSelected) {
        draft.selected.byId[payload.id] = true;
        draft.selected.allIds.push(payload.id);
      } else {
        draft.selected.byId[payload.id] = false;
        draft.selected.allIds = draft.selected.allIds.filter(
          id => id !== payload.id
        );
      }
      break;
    }

    case uiActions.SELECT_ALL: {
      const payload = action.payload;
      const byId = action.payload.list.reduce((obj, id) => {
        obj[id] = true;
        return obj;
      }, {});
      if (payload.isSelected) {
        draft.selected.byId = byId;
        draft.selected.allIds = [...action.payload.list];
      } else {
        draft.selected.byId = {};
        draft.selected.allIds = [];
      }
      break;
    }

    case uiActions.CLEAR_ERROR: {
      draft.errorMessage = null;
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
